import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { authForgotPassword } from '../lib/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [done, setDone] = useState(false);
  const [message, setMessage] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const r = await authForgotPassword(email.trim());
      if (!r.ok) {
        setErr(r.message ?? r.error);
        return;
      }
      setMessage(
        r.message ??
          'Als dit e-mailadres bij ons bekend is, ontvang je zo een mail met een link. Geen mail? Controleer spam of neem contact op.'
      );
      setDone(true);
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <Seo
        path="/wachtwoord-vergeten"
        title="Wachtwoord vergeten"
        description="Vraag een resetlink aan voor je ComfortTool™-account."
        keywords="ComfortTool wachtwoord vergeten"
        noindex
      />
      <div className="mx-auto max-w-md px-4 py-12">
        <h1 className="text-2xl font-bold text-ct-text">Wachtwoord vergeten</h1>
        <p className="mt-2 text-sm text-ct-muted">
          Vul je e-mailadres in. Als dit adres bij ons bekend is, sturen we je een mail met een link. Geen mail?
          Controleer je spamfolder — of wachtwoord-mail staat voor deze site nog niet aan; gebruik dan contact.
        </p>
        {done ? (
          <p className="mt-6 text-sm text-ct-muted" role="status">
            {message}
          </p>
        ) : (
          <form className="mt-8 space-y-4" onSubmit={(e) => void onSubmit(e)}>
            <div>
              <label className="block text-sm font-medium text-ct-text" htmlFor="forgot-email">
                E-mail
              </label>
              <input
                id="forgot-email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1 w-full rounded-lg border border-ct-border bg-ct-bg px-3 py-2 text-ct-text"
              />
            </div>
            {err ? (
              <p className="text-sm text-red-400" role="alert">
                {err}
              </p>
            ) : null}
            <button
              type="submit"
              disabled={busy}
              className="w-full rounded-xl bg-ct-accent py-2.5 text-sm font-bold text-white hover:bg-blue-500 disabled:opacity-50"
            >
              {busy ? 'Bezig…' : 'Verstuur link'}
            </button>
          </form>
        )}
        <p className="mt-6 text-center text-sm text-ct-muted">
          <Link to="/inloggen" className="font-semibold text-ct-accent hover:underline">
            Terug naar inloggen
          </Link>
        </p>
      </div>
    </>
  );
}
